import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import size from 'lodash/size';
import isArray from 'lodash/isArray';
import { useNavigate } from 'react-router-dom';
import { queryClient } from '../../utils/queryClient';
import { QUERY_KEYS } from '../../config/constants';

import { useImportTemplate } from '../../hooks/react-query/useImport';
import { useUploadDriver } from '../../hooks/react-query/useDrivers';

import {
  Accordion,
  AccordionItem,
  AccordionContent,
  AccordionTrigger,
} from '../../components/ui/Accordion';
import { BackButton, CustomModal, PageTitle } from '../../components/ui';
import {
  DownloadTemplate,
  InfoIcon,
  LeftArrow,
  SpinnerIcon,
  TrashIcon,
} from '../../icons';
import { FileUploadIcon } from '../../icons/fileUploadIcon';
import { UploadIcon } from '../../icons/uploadIcon';
import { getFormJSON } from '../../utils/functions';
import { toast } from '../../components/ui/Toast/useToast';
import ImportDriverTable from '../../components/drivers/importDriverTable';

import ImportDriverDetailsTable from '../../components/drivers/importDriverDetailsTable';
import { Rounded } from '../../components/elements/rounded';
import ToolBar from '../../components/drivers/toolBar';
const { MULTIPLE_UPLOAD_LIST } = QUERY_KEYS;

const ImportDrivers = ({ isFromDrivers, handleBackClick }) => {
  const navigate = useNavigate();

  const { refetch, isFetching: isImportLoading } = useImportTemplate(
    'importDriversTemplate.xlsx'
  );

  const { mutate: uploadDriverTemplate, isLoading } = useUploadDriver();

  const [selectedTableRow, setSelectedTableRow] = useState();

  const [fileUploadState, setFileUploadState] = useState({
    file: {},
    driversMimeType: '',
    urlErrors: '',
  });

  const handleDownloadClick = () => {
    refetch();
  };

  const handleRejectedFiles = () => {};

  const handleFileChange = (fileArr) => {
    const [file] = fileArr;

    if (file) {
      let type = file.type.split('/')[1];
      let fileName = file.name;
      const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      setFileUploadState({
        file: { file, name: fileName, fileSize: `${sizeInMB} MB` },
        driversMimeType: type,
        urlErrors: '',
      });
    }
  };

  const handleFileUpload = (event) => {
    event.preventDefault();
    let jsonData = getFormJSON(event);
    let data = new FormData(event.target);
    if (fileUploadState.file.file) {
      jsonData['file'] = fileUploadState.file.file;
      data.set('file', fileUploadState.file.file);
    }

    uploadDriverTemplate(data, {
      onSuccess: (response) => {
        if (response?.data === 'success') {
          if (response.data.exceptions) {
            if (size(response.data.exceptions) > 0) {
              const exceptionsArray = isArray(response.data.exceptions);
              const message = exceptionsArray
                ? response.data.exceptions.slice(-1)
                : 'Παρουσιάστηκε κάποιο πρόβλημα';
              toast({
                variant: 'destructive',
                description: message || 'Παρουσιάστηκε κάποιο πρόβλημα',
              });
              setFileUploadState({
                file: { file: '', name: '' },
                driversMimeType: '',
              });
            }
          } else {
            queryClient.invalidateQueries({ queryKey: [MULTIPLE_UPLOAD_LIST] });
            toast({
              variant: 'success',
              description: 'Επιτυχής υποβολή αρχείου.\nΕλέγξτε το Ιστορικό Καταχωρίσεων',
            });

            setFileUploadState({
              file: { file: '', name: '' },
              driversMimeType: '',
            });
          }
        } else {
          setFileUploadState({
            file: { file: '', name: '' },
            driversMimeType: '',
          });
          toast({
            variant: 'destructive',
            description: 'Παρουσιάστηκε κάποιο πρόβλημα',
          });
        }
      },
    });
  };

  const handleCancelClick = () => {
    setFileUploadState({
      file: { file: '', name: '' },
      driversMimeType: '',
      urlErrors: '',
    });
  };

  const handleExpendClick = (selectedRow) => {
    setSelectedTableRow(selectedRow);
  };

  if (selectedTableRow && selectedTableRow.id) {
    return (
      <ImportDriverDetailsTable
        tableDetails={selectedTableRow}
        queryData={{ id: selectedTableRow.id }}
        handleBackButtonClick={() => setSelectedTableRow(null)}
      />
    );
  }
  const isFileSelected =
    !!fileUploadState?.file && !!fileUploadState?.file.file;

  return (
    <>
      <form onSubmit={handleFileUpload}>
        <section className="container mx-auto lg:py-10 py-5 overflow-x-hidden">
          <div className="flex flex-col lg:gap-6 gap-3 lg:pb-6 pb-3">
            {isFromDrivers && (
              <BackButton
                text="Επιστροφή"
                handleBackClick={handleBackClick}
              />
            )}
            <PageTitle
              title={
                isFromDrivers ? (
                  <div className="flex justify-between">
                    <h2>Μαζική καταχώριση οδηγών</h2>
                    <ToolBar
                      handleAddMultipleDrivers={() => {}}
                      showAddDriver={false}
                    />
                  </div>
                ) : (
                  <div className="flex justify-between">
                    <div className="flex max-lg:gap-x-2 lg:items-center">
                      <button
                          type="button"
                          className='h-fit max-lg:p-2'
                        onClick={() => navigate('/dashboard')}
                      >
                        <LeftArrow className={'lg:w-[24px] lg:h-[24px] w-[16px] h-[16px] stroke-black'}/>
                      </button>
                      <h2>Μαζική καταχώριση οδηγών</h2>
                    </div>
                    <ToolBar
                      handleAddMultipleDrivers={() => {}}
                      showAddDriver={false}
                    />
                  </div>
                )
              }
              subTitle={
                `Για να πραγματοποιήσεις μαζική καταχώριση, κατέβασε το παρακάτω υπόδειγμα, συμπλήρωσε τις απαραίτητες πληροφορίες και ανέβασε το ενημερωμένο αρχείο.\nΣτη συνέχεια, έλεγξε το Ιστορικό Καταχωρίσεων για να επιβεβαιώσεις την επιτυχή ολοκλήρωση των εγγράφων.`
              }
              displaySearch={false}
              className="w-full"
            />
          </div>

          <div className="grid lg:grid-cols-2 gap-x-5 max-lg:gap-6">
            <div className="flex  flex-col gap-y-3 p-6 bg-white rounded-[12px]">
              <div className="flex items-center gap-6 max-lg:border-b max-lg:border-b-fadedgrey max-lg:pb-3">
                <div className="flex items-center  justify-center border border-solid border-primary rounded-full w-8 h-8 lg:w-[64px] lg:h-[64px]">
                  <h3 className="lg:text-[32px] text-[19px] max-lg:h5 text-primary lg:pl-2">1.</h3>
                </div>
                <h3 className="max-lg:text-[14px]">Κατέβασε το υπόδειγμα</h3>

                <CustomModal
                  triggerComponent={
                    <span className="lg:hidden">
                      <InfoIcon />
                    </span>
                  }
                  handleClick={() => {}}
                >
                  <div className="container-sm lg:mx-auto flex flex-col items-center gap-y-3 lg:gap-y-5 max-lg:px-5">
                    <div className="flex gap-3 items-center flex-col w-full py-5 lg:py-6 lg:px-6">
                      <h3 className="max-lg:place-self-start">Οδηγίες συμπλήρωσης</h3>
                    </div>
                    <ul className="flex flex-col gap-y-4">
                      {/* =========== NEW =========== */}
                        <li className="text-body text-midgrey">
                          <b className="font-bold">1.</b> Ο πρώτος οδηγός που θα προστεθεί με επιτυχία για κάθε πινακίδα θα οριστεί αυτόματα ως κύριος οδηγός του αυτοκινήτου. Στη συνέχεια, μπορείς να αλλάξεις τον κύριο οδηγό οποιαδήποτε στιγμή.
                        </li>
                        {/* =========== NEW =========== */}
                        {/* Also changed the numbers for the rest of lis */}
                        <li className="text-body text-midgrey">
                          <b className="font-bold">2.</b> Οι τίτλοι των στηλών πρέπει να έχουν την ίδια ονομασία και σειρά με το υπόδειγμα.
                        </li>
                        <li className="text-body text-midgrey">
                          <b className="font-bold">3.</b> Η μορφή των στηλών πρέπει να παραμείνει όπως εμφανίζεται στο υπόδειγμα.
                        </li>
                        <li className="text-body text-midgrey">
                          <b className="font-bold">4.</b> Για τις πινακίδες, πρέπει να χρησιμοποιούνται κεφαλαίοι λατινικοί χαρακτήρες
                        </li>
                        <li className="text-body text-midgrey">
                          <b className="font-bold">5.</b> Τα αυτοκίνητα/πινακίδες που θα ενημερώσεις πρέπει να ανήκουν στο ΑΦΜ στο οποίο έχετε συνδεθεί ως διαχειριστής στόλου.
                        </li>
                        <li className="text-body text-midgrey">
                          <b className="font-bold">6.</b> Κάθε οδηγός που προστίθεται/ενημερώνεται πρέπει να έχει μοναδικό email  
                        </li>
                        <li className="text-body text-midgrey">
                          <b className="font-bold">7.</b> Ένας οδηγός μπορεί να προστεθεί σε πολλαπλά αυτοκίνητα.
                        </li>
                        <li className="text-body text-midgrey">
                          <b className="font-bold">8.</b> Οι οδηγοί που προστίθενται πρέπει να είναι τουλάχιστον 21 ετών.
                        </li>
                    </ul>
                  </div>
                </CustomModal>
              </div>
              <div className='flex flex-col gap-3 max-lg:hidden bg-[#F5F5F7] rounded-md p-2'>
                <h3>Οδηγίες</h3>
                <ul className="flex flex-col gap-2">
                   {/* =========== NEW =========== */}
                  <li className="text-body text-midgrey">
                    <b className="font-bold">1.</b> Ο πρώτος οδηγός που θα προστεθεί με επιτυχία για κάθε πινακίδα θα οριστεί αυτόματα ως κύριος οδηγός του αυτοκινήτου. Στη συνέχεια, μπορείς να αλλάξεις τον κύριο οδηγό οποιαδήποτε στιγμή.
                  </li>
                  {/* =========== NEW =========== */}
                  {/* Also changed the numbers for the rest of lis */}
                  <li className="text-sm text-midgrey">
                    <b className="font-bold">2.</b> Οι τίτλοι των στηλών πρέπει να έχουν την ίδια ονομασία και σειρά με το υπόδειγμα.
                  </li>
                  <li className="text-sm text-midgrey">
                    <b className="font-bold">3.</b> Η μορφή των στηλών πρέπει να παραμείνει όπως εμφανίζεται στο υπόδειγμα.
                  </li>
                  <li className="text-sm text-midgrey">
                    <b className="font-bold">4.</b> Για τις πινακίδες, πρέπει να χρησιμοποιούνται κεφαλαίοι λατινικοί χαρακτήρες
                  </li>
                  <li className="text-sm text-midgrey">
                    <b className="font-bold">5.</b> Τα αυτοκίνητα/πινακίδες που θα ενημερώσεις πρέπει να ανήκουν στο ΑΦΜ στο οποίο έχετε συνδεθεί ως διαχειριστής στόλου.
                  </li>
                  <li className="text-sm text-midgrey">
                    <b className="font-bold">6.</b> Κάθε οδηγός που προστίθεται/ενημερώνεται πρέπει να έχει μοναδικό email
                  </li>
                  <li className="text-sm text-midgrey">
                    <b className="font-bold">7.</b> Ένας οδηγός μπορεί να προστεθεί σε πολλαπλά αυτοκίνητα.
                  </li>
                  <li className="text-sm text-midgrey">
                    <b className="font-bold">8.</b> Οι οδηγοί που προστίθενται πρέπει να είναι τουλάχιστον 21 ετών.
                  </li>
                </ul>
              </div>
              <div className="flex justify-between lg:border-t lg:border-[#E2E2E2] lg:pt-6">
                <div className="flex gap-2">
                  <FileUploadIcon />
                  <div className="flex flex-col gap-1">
                    <span className="h6 text-genite">Template.xls</span>
                    <span className="text-body text-fadedgrey">1.02 MB</span>
                  </div>
                </div>
                <div>
                  <button
                    type="button"
                    className="max-lg:hidden btn-primary text-primary-button"
                    onClick={handleDownloadClick}
                  >
                    {isImportLoading && <SpinnerIcon />} Λήψη
                  </button>
                  <button
                    type="button"
                    className="lg:hidden"
                    onClick={handleDownloadClick}
                  >
                    {isImportLoading ? (
                      <SpinnerIcon className="w-5 h-5 fill-primary" />
                    ) : (
                      <DownloadTemplate className="fill-primary w-[40px] h-[40px]" />
                    )}
                  </button>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-y-4 lg:gap-y-6 p-6 bg-white rounded-[12px] justify-between">
              <div className="flex items-center gap-6 max-lg:border-b max-lg:border-b-fadedgrey max-lg:pb-3">
                <div className="flex items-center justify-center border border-solid border-primary rounded-full w-8 h-8 lg:w-[64px] lg:h-[64px]">
                  <h3 className="lg:text-[32px] text-[19px] max-lg:h5 text-primary lg:pl-2">2.</h3>
                </div>
                <h3 className="max-lg:text-[14px]">Ανέβασε το νέο αρχείο</h3>
              </div>
              <div className="flex justify-center">
                <Dropzone
                  onDrop={(acceptedFiles) =>
                    handleFileChange(acceptedFiles, 'deposit')
                  }
                  accept={{
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                      ['.xlsx'],
                  }}
                  noClick={true}
                  noKeyboard={true}
                  maxFiles={1}
                  id="upload-btn-id-front"
                  name="deposit"
                  onDropRejected={(errors) => handleRejectedFiles(errors)}
                >
                  {({ getRootProps, getInputProps, open, isDragActive }) => (
                    <div
                      {...getRootProps({
                        className: `${isDragActive && 'flex justify-between'}
                          ${
                            isFileSelected
                              ? 'max-lg:p-3 border border-fadedgrey lg:border-dashed'
                              : 'lg:border border-fadedgrey lg:border-dashed'
                          }
                         lg:p-3 rounded-xl flex-col lg:h-[172px] w-full`,
                      })}
                    >
                      {isFileSelected && (
                        <div className="flex justify-between w-full">
                          <FileUploadIcon />
                          <Rounded className="border border-fadedgrey lg:w-[32px] h-[32px] w-[32px] flex items-center justify-center">
                            <TrashIcon
                              onClick={handleCancelClick}
                              className={'lg:w[32px] max-lg:w-[19px]'}
                              color="#4E4E4E"
                            />
                          </Rounded>
                        </div>
                      )}

                      <label
                        htmlFor="uploadDrivers"
                        onClick={open}
                        className={`uploader-label w-full lg:h-full lg:pb-6 flex ${
                          isFileSelected
                            ? 'items-end'
                            : 'item-end lg:items-center justify-between lg:justify-center'
                        }
                           `}
                      >
                        <span
                          className={`text-fadedgrey text-body self-center lg:hidden ${
                            isFileSelected && 'hidden'
                          }`}
                        >
                          Υποβολή
                        </span>
                        <input
                          // id="uploadDrivers"
                          {...getInputProps()}
                          className="h-[172px]"
                        />
                        {isDragActive && (
                          <div className="uploader-drag-drop standing-order">
                            Αφήστε Εδώ
                          </div>
                        )}
                        {!fileUploadState ||
                          (!fileUploadState.file?.name && (
                            <div className="flex flex-col items-center justify-center gap-4">
                              <UploadIcon />
                            </div>
                          ))}
                        <div
                          className={
                            isDragActive || !isFileSelected
                              ? 'hidden'
                              : 'flex flex-col justify-end pb-3'
                          }
                        >
                          <h5 className="text-fadedgrey">
                            {fileUploadState.file?.name}
                          </h5>
                          <div className="pt-2 text-body text-fadedgrey">
                            {fileUploadState.file?.fileSize}
                          </div>
                        </div>
                      </label>
                    </div>
                  )}
                </Dropzone>
              </div>
              <div className="flex justify-center border-t border-[#E2E2E2] xl:pt-6">
                <button
                  type="submit"
                  className="btn-primary text-primary-button flex gap-2 justify-center items-center max-lg:w-full"
                  disabled={!fileUploadState || !fileUploadState.file?.name}
                >
                  {isLoading && <SpinnerIcon />}
                  Υποβολή
                </button>
              </div>
            </div>
          </div>
        </section>
      </form>

      <ImportDriverTable handleExpendClick={handleExpendClick} />
    </>
  );
};

export default ImportDrivers;
